import React, { FC } from 'react'
import { Button, Heading, Icon, Modal, Text } from '@afterpaytouch/core'
import { useSection75DisputeModalContext } from '../../Section75DisputeModalContext'
import { useDisputeTranslation } from '../../../hooks'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { TrackOnMount } from '../../../../../integrations/amplitude'
import { TrackingEvent } from '../../../../../model/amplitude'

export const CreateSuccess: FC = () => {
  const t = useDisputeTranslation()
  const { textSize } = useConsumerSizes()
  const { closeModal } = useSection75DisputeModalContext()

  return (
    <>
      <TrackOnMount eventName={TrackingEvent.VIEWED_CREATE_DISPUTE_SUCCESS} />
      <Modal.Header divider={true}>
        <div className='absolute z-10 pt-1'>
          <Button.Link size='Small' onClick={closeModal}>
            <Icon.CaretLeft size='Small' />
          </Button.Link>
        </div>
        <div className='text-center'>
          <Heading size='L'>{t('section75DisputeModal:result:success:head')}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className='mb-4'>
          <Text size={textSize}>{t('section75DisputeModal:result:success:subtitle')}</Text>
        </div>

        <div className='mb-4'>
          <Heading size='M'>{t('section75DisputeModal:result:success:nextStepHeading')}</Heading>
          <ul>
            <li>
              <Text size={textSize}>{t('section75DisputeModal:result:success:nextStep1')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('section75DisputeModal:result:success:nextStep2')}</Text>
            </li>
          </ul>
        </div>

        <div className='mb-8'>
          <Heading size='M'>{t('section75DisputeModal:result:success:instalmentsHeading')}</Heading>
          <ul>
            <li>
              <Text size={textSize}>{t('section75DisputeModal:result:success:instalments1')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('section75DisputeModal:result:success:instalments2')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('section75DisputeModal:result:success:instalments3')}</Text>
            </li>
          </ul>
        </div>

        <div className='mt-auto'>
          <Button padding='Fluid' size='Large' onClick={closeModal}>
            {t('section75DisputeModal:result:success:closeCTA')}
          </Button>
        </div>
      </Modal.Content>
    </>
  )
}
